<div
[ngClass]="{
    'sticky-note-section': true,
    'p-0': isDashboard,
    'note-gap-2': sessionType === 'OPD' && allNotes?.length === 0
  }">
    <div class="note-buttons" *ngIf="isCurrentUser">
        <button class="sticky-note-btn" [disabled]="!isPractitioner()" *ngIf="sessionType !== 'OPD'" (click)="addPreNote('PRE')">
          <i class="pi pi-bookmark"></i> Pre Session Note
        </button>
        <button class="sticky-note-btn" [disabled]="!isPractitioner()" (click)="addPostNote('POST')">
          <i class="pi pi-bookmark"></i> Post Session Note
        </button>
      </div>
    
      <div class="note-timeline">
        <ng-container *ngIf="allNotes?.length > 0; else noNotes">
            <div class="note-card" *ngFor="let note of allNotes">
              <div class="note-header">
                <span class="tag">{{ note.noteType }}</span>
                <span class="note-date" (click)="viewNote(note)">
                  {{ note.createdAt | date: 'medium' }}
                </span>
                <i *ngIf="isCurrentUser" class="pi pi-trash" (click)="onInactive(note)"></i>
              </div>
            </div>
          </ng-container>
          
          <ng-template #noNotes>
            <p class="no-notes-text">No session notes found.</p>
          </ng-template>          
      </div>
</div>
  

<app-sticky-note
    *ngFor="let note of notes; let i = index"
    [content]="note.content"
    [top]="note.top"
    [left]="note.left"
    [index]="i"
    [isCurrentUser]="isCurrentUser"
    (positionChange)="updatePosition($event)"
    (delete)="deleteNote($event)"
    (save)="handleNoteSubmit($event)"
></app-sticky-note>